import React, { useEffect } from 'react';

import {Layer, Source, useMap} from 'react-map-gl';
import { useDispatch, useSelector } from 'react-redux';

import { useResponsive } from '../hooks/useResponsive';
import { 
  pathBusLayerAsLine,
  pathUnderBusLayerAsLine, 
  pathLayerAsLine,
  lightPathLayerAsLine,
  unselectedPathLayer, 
  // underUnselectedPathLayer,
} from '../mapStyles';
import { setStateDisable } from '../store/actions/disableActions';
import { setContentType, setOpenSideBar } from '../store/actions/sideBarActions';
import { closeWelcomeModal } from '../store/actions/modalActions';
import greenCirclePNG from '../images/circleGreen.png';
import orangeCirclePNG from '../images/circleOrange.png';
import redCirclePNG from '../images/circleRed.png';
import greyCirclePNG from '../images/circleGrey.png';
import { getBounds } from '../utils/useBounds';
import { setSelectedPath } from '../store/actions/directionsActions';
import { setShowActiveGraphLayer } from '../store/actions/mapActions';


const layerLineBusStyle = pathBusLayerAsLine('t', 'c');
const layerUnderLineBusStyle = pathUnderBusLayerAsLine('t', 'c');
const unselectedPathStyle = unselectedPathLayer(4);
// const underUnselectedPathStyle = underUnselectedPathLayer(4);


function testAreEqual(prevRoad, nextRoad) {
  if (JSON.stringify(prevRoad.origin) !== JSON.stringify(nextRoad.origin)) {
    return false;
  } else if (JSON.stringify(prevRoad.destination) !== JSON.stringify(nextRoad.destination)) {
    return false;
  } else if (prevRoad.condition !== nextRoad.condition || prevRoad.profil !== nextRoad.profil || prevRoad.multimodal !== nextRoad.multimodal) {
    return false;
  } else if ( prevRoad.dateSelected !== nextRoad.dateSelected ) {
    return false;
  } else if ( prevRoad.allResults !== nextRoad.allResults ) {
    return false;
  } else if ( prevRoad.status !== nextRoad.status ) {
    return false;
  }
  return true;
}

const RoadmapLayer = ({
  profil, 
  condition, 
  multimodal, 
  dateSelected, 
  setPathLayerList, 
  status, 
  allResults,
  stylePath
}) => {
  const dispatch = useDispatch();
  
  const selectedPathNumber = useSelector(state => state.directions.selectedPath);
  const contentType = useSelector(state => state.sideBar.contentType);
  const openWelcome = useSelector(state => state.modalZone.welcome);
  const activeBaseLayer = useSelector(state => state.map.activeBaseLayer);

  const {mymap} = useMap();
  const {isMobile} = useResponsive();
  const [selectedPathGeoJson, setSelectedPathGeoJson] = React.useState(null);
  const [notSelectedPathGeoJson, setNotSelectedPathGeoJson] = React.useState([]);

  const [styleLine, setStyleLine] = React.useState(stylePath ? stylePath('acc', 't') : pathLayerAsLine('acc', 't'));
 
  useEffect(() => {
    if (status === 'loading') {
      dispatch(setStateDisable(true));
    } else {
      dispatch(setStateDisable(false));
    }
    if (status === 'success' && allResults.length > 0) {
      if (selectedPathNumber > allResults.length - 1) {
        dispatch(setSelectedPath(0));
        setSelectedPathGeoJson(allResults[0].geojson);
        const boundingBox = getBounds(allResults[0].geojson);
        if (boundingBox !== undefined) {
          mymap?.fitBounds(boundingBox, {
            padding: {
              top: isMobile ? 100 : 50,
              bottom: isMobile ? 100 : 20,
              left: isMobile ? 50: 10,
              right: isMobile ? 50: 20
            }
          });
        }
      } else {
        dispatch(setSelectedPath(selectedPathNumber));
        setSelectedPathGeoJson(allResults[selectedPathNumber].geojson);
        const boundingBox = getBounds(allResults[selectedPathNumber].geojson);
        if (boundingBox !== undefined) {
          mymap?.fitBounds(boundingBox, {
            padding: {
              top: isMobile ? 100 : 50,
              bottom: isMobile ? 100 : 20,
              left: isMobile ? 50: 25,
              right: isMobile ? 50: 25
            }
          });
        }
        setPathLayerList(['selectedpath_line', 'selectedpath_bus_line']);
        if (contentType === 'direction') {
          const featuresCollection = allResults.map((path, i) => {
            if (i !== selectedPathNumber){
              return path.geojson;
            } else {
              return {
                type: 'FeatureCollection',
                features: []
              };
            }
          });
          setNotSelectedPathGeoJson(featuresCollection);
        } else {
          setNotSelectedPathGeoJson([]);
        }
      } 
    } else {
      setNotSelectedPathGeoJson([]);
      setSelectedPathGeoJson(null);
      setPathLayerList([]);
    }
    /**
       * Passer l'instance de map vers l'objet Window 
       * utilisé par les tests Cypress
       */    
    window.mapInfo = mymap;
  }, [ status, profil, condition, multimodal, dateSelected ]);

  useEffect(() => {
    if (status === 'success' && allResults.length > 0) {
      setSelectedPathGeoJson(allResults[selectedPathNumber].geojson);
      const boundingBox = getBounds(allResults[selectedPathNumber].geojson);
      if (boundingBox !== undefined) {
        mymap?.fitBounds(boundingBox, {
          padding: {
            top: isMobile ? 100 : 50,
            bottom: isMobile ? 100 : 20,
            left: isMobile ? 50: 25,
            right: isMobile ? 50: 25
          }
        });
        setPathLayerList(['selectedpath_line', 'selectedpath_bus_line']);
      }
      if (contentType === 'direction') {
        const featuresCollection = allResults.map((path, i) => {
          if (i !== selectedPathNumber){
            return path.geojson;
          }else {
            return {
              type: 'FeatureCollection',
              features: []
            };
          }
          
        });
        setNotSelectedPathGeoJson(featuresCollection);
      } else {
        setNotSelectedPathGeoJson([]);
      }
    } else {
      setNotSelectedPathGeoJson([]);
      setSelectedPathGeoJson(null);
      setPathLayerList([]);
    }
    
  }, [selectedPathNumber]);


  useEffect(() => {
    if (status === 'error' || status === 'success') {
      dispatch(setOpenSideBar(false));
      dispatch(setContentType('direction'));
    } else {
      return;
    }
  }, [status, selectedPathNumber]);

  useEffect(() => {
    if (contentType === 'stepsDetails' && allResults.length > 0) {
      const boundingBox = getBounds(allResults[selectedPathNumber].geojson);
      if (boundingBox !== undefined && boundingBox !== null) {
        mymap?.fitBounds(boundingBox, {
          padding: {
            top: isMobile ? 100 : 50,
            bottom: isMobile ? 100 : 20,
            left: isMobile ? 50: 25,
            right: isMobile ? 50: 25
          }
        });
      }
      dispatch(setOpenSideBar(true));
    } else {
      return;
    }

  }, [contentType]);

  useEffect(() => {
    if (mymap !== undefined && mymap !== null) {
      if (!mymap.hasImage('green-circle')) {
        mymap.loadImage(greenCirclePNG, (error, image) => {
          mymap.addImage('green-circle', image, { sdf: false });
        });
      }
      if (!mymap.hasImage('orange-circle')) {
        mymap.loadImage(orangeCirclePNG, (error, image) => {
          mymap.addImage('orange-circle', image, { sdf: false });
        });
      }
      if (!mymap.hasImage('red-circle')) {
        mymap.loadImage(redCirclePNG, (error, image) => {
          mymap.addImage('red-circle', image, { sdf: false });
        });
      }
      if (!mymap.hasImage('grey-circle')) {
        mymap.loadImage(greyCirclePNG, (error, image) => {
          mymap.addImage('grey-circle', image, { sdf: false });
        });
      }
    }
  }, [mymap]);

  useEffect(() => {
    if (status === 'success' && allResults.length > 0) {
      dispatch(setShowActiveGraphLayer(false));
      if (openWelcome) {
        dispatch(closeWelcomeModal());
      }
    } else {
      if (status === 'loading') {
        dispatch(setShowActiveGraphLayer(false));
      }
    }
  }, [status]);

  useEffect(() => {
    if (activeBaseLayer === 'osm-tiles') {
      setStyleLine(stylePath ? stylePath('acc', 't') : pathLayerAsLine('acc', 't'));
    }
    if (activeBaseLayer === 'ortho-tiles') {
      setStyleLine(stylePath ? stylePath('acc', 't') : lightPathLayerAsLine('acc', 't'));
    }
  }, [activeBaseLayer]);
  
  return (
    <>
      {selectedPathGeoJson &&
        <Source key='selectedpath' id={'selectedpath'} type='geojson' data={selectedPathGeoJson}>
          <Layer 
            key='selectedpath_bus_line'
            id='selectedpath_bus_line' 
            {...layerLineBusStyle}
          />
          <Layer
            {...layerUnderLineBusStyle}
            key='selectedpath_under_bus_line'
            id='selectedpath_under_bus_line'
            beforeId='selectedpath_bus_line'
          />
          <Layer 
            key='selectedpath_line'
            id='selectedpath_line' 
            {...styleLine}
          />
        </Source>
      }

      {contentType === 'direction' && notSelectedPathGeoJson.map((path, i) => {
        return (
          <div key={`path_${i}`}>
            <Source key={`path_${i}`} id={`path_${i}`} type='geojson' data={path}>
              <Layer 
                key={`path_${i}`}
                id={`path_${i}`}
                beforeId='selectedpath_bus_line' 
                {...unselectedPathStyle}
              />
              {/* <Layer 
                key={`underUnselectedpath_${i}`} 
                id={`underUnselectedpath_${i}`} 
                beforeId={`path_${i}`}
                {...underUnselectedPathStyle} 
              /> */}
            </Source>
          </div>
        );
      })}

    </>
  );
};

export const PathsLayer = React.memo(RoadmapLayer, testAreEqual);